import { footerGroups, footerNote } from '@/mocks/home';
import { useToast } from '@/components/base/Toast';

export default function SiteFooter() {
  const showToast = useToast();

  return (
    <footer className="bg-secondary-900 text-background-200">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-foreground-950">
                撸
              </span>
              <div className="leading-tight">
                <p className="font-heading text-xl font-bold text-background-50">撸撸射</p>
                <p className="text-[11px] tracking-[0.28em] text-background-400">入口导航</p>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-7 text-background-300">{footerNote}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['官网地址', '最新网址', '导航站', '手机直达'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-secondary-700 px-3 py-1.5 text-xs font-medium text-background-300"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-7">
            {footerGroups.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                  <a href="#top" className="transition-colors hover:text-primary-300">
                    {group.title}
                  </a>
                </h4>
                <ul className="mt-4 flex flex-col gap-3">
                  {group.links.map((link) => (
                    <li key={link}>
                      <button
                        type="button"
                        onClick={() => showToast(`「${link}」相关入口正在为你准备`)}
                        className="cursor-pointer text-left text-sm text-background-300 transition-colors hover:text-primary-300"
                      >
                        {link}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">© 2026 撸撸射入口导航 · 信息整理与访问方式展示</p>
          <div className="flex flex-wrap items-center gap-5 text-xs text-background-400">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-sm text-primary-300" aria-hidden="true"></i>
              入口持续核验
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line text-sm text-primary-300" aria-hidden="true"></i>
              最新地址实时同步
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}